import { createSelector } from 'reselect';

import { IRootState } from '../../../reducers';
import { mapCreationRewardsResponse } from './mappers';

const creationRewardsSelector = createSelector(
  [
    (state: IRootState) => state.studentRewards,
    (state: IRootState) => state.studentEvents,
    (state: IRootState) => state.sectionRef,
  ],
  (studentRewards, studentEvents, sectionRef) => {
    return mapCreationRewardsResponse(studentEvents, studentRewards, sectionRef);
  },
);

export default creationRewardsSelector;
